/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {NavLink, Outlet, useParams} from 'react-router-dom'
import {appsAPI} from '../../services/AppsService'
import {EmptyAppPage} from './components/EmptyAppPage'
import {PanelAppItem} from './components/panel_app/PanelAppItem'
import {usersAPI} from '../../services/UsersService'
import {useIntl} from 'react-intl'

const AppsHeader: FC = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const {data: app, isLoading, error} = appsAPI.useFetchAppByIdQuery(appId!)
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()

  if (app === null || error) {
    return <EmptyAppPage error={error} />
  }

  return (
    <>
      {isLoading ? (
        intl.formatMessage({id: 'WAIT'})
      ) : (
        <>
          <div className='d-flex flex-column flex-lg-row'>
            <PanelAppItem app={app!} firstElement={false} />
            <div className='flex-lg-row-fluid ms-lg-7'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-6 fw-bolder flex-nowrap mb-5'>
                <li className='nav-item'>
                  <NavLink className='nav-link text-muted text-active-primary text-hover-primary' to='./'>
                    <small className='text-uppercase'>{intl.formatMessage({id: 'APP.HEADER.INFO'})}</small>
                  </NavLink>
                </li>
                {app?.crm !== 'ONEC' && app?.crm !== 'ROISTAT' && (
                  <li className='nav-item'>
                    <NavLink className='nav-link text-muted text-active-primary text-hover-primary' to='lines/'>
                      <small className='text-uppercase'>{intl.formatMessage({id: 'APP.HEADER.LINES'})}</small>
                    </NavLink>
                  </li>
                )}
                {app?.crm !== 'ONEC' && app?.crm !== 'ROISTAT' && (
                  <li className='nav-item'>
                    <NavLink className='nav-link text-muted text-active-primary text-hover-primary' to='users/'>
                      <small className='text-uppercase'>{intl.formatMessage({id: 'APP.HEADER.USERS'})}</small>
                    </NavLink>
                  </li>
                )}
                <li className='nav-item'>
                  <NavLink className='nav-link text-muted text-active-primary text-hover-primary' to='license/'>
                    <small className='text-uppercase'>{intl.formatMessage({id: 'APP.HEADER.LICENSE'})}</small>
                  </NavLink>
                </li>
                <li className='nav-item'>
                  <NavLink className='nav-link text-muted text-active-primary text-hover-primary' to='logs/'>
                    <small className='text-uppercase'>{intl.formatMessage({id: 'APP.HEADER.LOGS'})}</small>
                  </NavLink>
                </li>
                {currentUser?.role === 'ADMIN' && (
                  <li className='nav-item'>
                    <NavLink className='nav-link text-muted text-active-primary text-hover-primary' to='admin/'>
                      <small className='text-uppercase'>{intl.formatMessage({id: 'APP.HEADER.ADMIN'})}</small>
                    </NavLink>
                  </li>
                )}
              </ul>
              <Outlet />
            </div>
          </div>
        </>
      )}
    </>
  )
}

export {AppsHeader}
